import { cn } from "@/lib/utils";
import { HTMLAttributes } from "react";
import { CopyButton } from "./copyButton";

interface Props extends HTMLAttributes<HTMLDivElement> {
  copyable?: boolean;
  children: string;
}

export function CommandSnippet({
  copyable,
  children,
  className,
  ...props
}: Props) {
  return (
    <div
      className={cn(
        "flex overflow-x-auto font-mono items-center text-nowrap w-full rounded-md border dark:text-brand-gray-100 bg-brand-gray-100 dark:bg-brand-gray-800 py-1 text-sm shadow-sm",
        className
      )}
      {...props}
    >
      <span className="sticky left-0 px-3 text-brand-gray-400 bg-inherit">
        $
      </span>
      <span className="flex-grow">{children}</span>

      {copyable && (
        <span className="sticky right-0 pl-3 pr-2 bg-inherit">
          <CopyButton copyText={children} variant="ghost" size="icon" />
        </span>
      )}
    </div>
  );
}
